import { render, staticRenderFns } from "./AppealsGrid.vue?vue&type=template&id=89e6a0fc&"
import script from "./AppealsGrid.vue?vue&type=script&lang=ts&"
export * from "./AppealsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./AppealsGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports